import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase';

import workers from '@/routes/modules/workers'
import settings from '@/routes/modules/settings'
import attendance from '@/routes/modules/attendance'
import finnance from '@/routes/modules/finnance'
import login from '@/routes/modules/login'
import dashboard from '@/routes/modules/dashboard'
import computingMetrics from '@/routes/modules/computingMetrics'
import PageNotFound from '../components/PageNotFound'

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [
		workers,
		settings,
		attendance,
		finnance,
		login,
		dashboard,
		computingMetrics,
		{ path: "*", component: PageNotFound }
	]
})

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
	const currentUser = firebase.auth().currentUser;

	if (requiresAuth && !currentUser) {
		next('login')
	} else if (requiresAuth && currentUser) {
		next()
	} else {
		next();
	}
})

router.afterEach(() => {
})

export default router;